module.exports = __webpack_public_path__ + "static/Phone-5baccbbcde52cf48f60ea1cdf2d6c612.png";